var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.276 14.2195V14.2195C34.53 14.2195 33.854 13.7895 33.536 13.1175C32.962 11.9015 32.232 10.3475 31.8 9.5015C31.162 8.2435 30.128 7.5115 28.696 7.5015C28.672 7.4995 19.328 7.4995 19.304 7.5015C17.872 7.5115 16.84 8.2435 16.2 9.5015C15.77 10.3475 15.04 11.9015 14.466 13.1175C14.148 13.7895 13.47 14.2195 12.726 14.2195V14.2195C8.734 14.2195 5.5 17.4535 5.5 21.4435V33.3155C5.5 37.3035 8.734 40.5395 12.726 40.5395H35.276C39.266 40.5395 42.5 37.3035 42.5 33.3155V21.4435C42.5 17.4535 39.266 14.2195 35.276 14.2195Z",
    stroke: "#714FFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6428 26.6687C17.6408 30.1747 20.5028 33.0427 24.0028 33.0407C27.4968 33.0367 30.3508 30.1807 30.3568 26.6827C30.3628 23.1707 27.5108 20.3087 24.0068 20.3047C20.4828 20.3007 17.6148 23.2107 17.6428 26.6687Z",
    stroke: "#714FFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.805 21.9902C33.6118 21.9703 33.4209 21.9199 33.2072 21.8339C32.9694 21.7283 32.7636 21.5939 32.5646 21.3917C32.207 21.0114 32 20.5141 32 20.001C32 19.7284 32.0557 19.4583 32.1645 19.2136C32.2736 18.9657 32.4028 18.7566 32.6364 18.5291C32.814 18.3744 32.996 18.2499 33.2448 18.1403C33.9826 17.8479 34.8602 18.0226 35.4087 18.5708C35.573 18.7328 35.7115 18.9282 35.7883 19.093L35.8338 19.2099C35.9443 19.4583 36 19.7284 36 20.001C36 20.5244 35.7956 21.0086 35.4163 21.4115C35.0884 21.7416 34.6578 21.9446 34.1984 21.9902L34 22L33.805 21.9902Z",
    fill: "#302E6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.55f293bf0a5c03a70682decefc6fa904.svg";
export { ForwardRef as ReactComponent };